import { FC, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import FooterText from "../../components/footerText";
import AuthSubHeader from "src/components/authSubHeader";

import useFetch from "src/hooks/useFetch";

import { APIEndpoints } from "src/types/apiTypes";


import Select,{ GroupBase, OptionsOrGroups, PropsValue, SingleValue } from "react-select";
import { PrecertAPIResponse } from "../precert/types";



const UpdatePrecert: FC = (): JSX.Element => {
  const [cancelReason, setCancelReason] = useState<string>('approved');
  const { caseId,prior_auth_id,precertsId } = useParams();
  const navigate = useNavigate();
   const location = useLocation();
   const queryParams = new URLSearchParams(location.search); // Parse query params
  const STATE_UPDATE_PA = [
    {
      value: 'approved',
      label: 'Approved',
    }, 
    {
      value: 'denied',
      label: 'Denied',
    },
     {
      value: 'cancelled',
      label: 'Cancelled',
    }
  ];
  //  const [patient,setPatient] = useState((location.state as { patient: string }).patient)


  // const { loading, data: requestPriorAuthorization, mutate: updatePriorAuthorization, error: priorAuthorizationError } = 
  // useFetch<RequestTreatmentNotTreatingApiResponse>(APIEndpoints.PRIOR_AUTHORIZATION);

const UpdatePrecertButton = () => {
//   const queryParam = {
//     status:cancelReason, 
//     case_id: caseId, 
//     id: prior_auth_id
// };
//   updatePriorAuthorization(queryParam, { id:prior_auth_id});
const pathParams = {
  case_id: caseId,
  id: precertsId
}
const queryParams = {
  status: cancelReason,
  case_id: caseId
}
// setPrecertPathParameters(pathParams)
fetchPrecertMutate({}, pathParams, queryParams)
}




const { mutate: fetchPrecertMutate, data: fetchPrecertResponse } =
    useFetch<PrecertAPIResponse>(APIEndpoints.UPDATE_PRECERT, {}, {}, false);

  useEffect(() => {
    if (fetchPrecertResponse) {
      navigate(`/cases`);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchPrecertResponse]);



  const navigateToUpdatePrecert = () => {
    const pathParams = {
      case_id: caseId,
      id: prior_auth_id
    }
    const queryParams = {
      precert_approval: false,
      status: 14,
      case_id: caseId
    }
    // setPrecertPathParameters(pathParams)
    fetchPrecertMutate({}, pathParams, queryParams)
  }

// useEffect(() => {
//   if (priorAuthorizationError){
//   }
//   if (requestPriorAuthorization) {
//     showToast([`Prior Authorization Saved and Completed`], ToastTypes.SUCCESS);
//     navigate('/cases',{ replace: true });
//     setCancelReason("Cost");
//     const { status } = requestPriorAuthorization;
//     if (status === 'ok') {
//       showToast([`Treatment Cancel Successfully`], ToastTypes.SUCCESS);
//       navigate(-1);
     
//     }
//   }
//   // eslint-disable-next-line react-hooks/exhaustive-deps
// }, [requestPriorAuthorization, priorAuthorizationError]);

const onChangeSelect = (value: SingleValue<string>) => {
  setCancelReason((value as unknown as { value: string; label: string; }).value);
};
const getValue = () => {
  const data = STATE_UPDATE_PA.find((option) => option.value === cancelReason);
  if (data) return data as unknown as PropsValue<string>;
};
  return (
      <div className={"container-fluid body-bg overflow-auto d-flex flex-column flex-fill"}>
        <div className="container">
          <AuthSubHeader />

          <div className="card mt-5">
            <div className="card-header">
              <p className="fs-2 m-0">
                Update PA Status for Case {caseId} {'(' + queryParams.get('patient') + ")"}
              </p>
            </div>
            <div className="card-header">
              <h4 className="mb-0">Insurance Name: {queryParams.get('insuranceName')}</h4>
            </div>

            <div className="card-body">
              <p className="text-center"> if you've received updated information or wish to cancel your PA, select a
                status from the dropdown below and the system will update this case for you. </p>

              <div className="row align-items-center">


                <div className="col-12 col-md-10">
                  <Select
                      options={STATE_UPDATE_PA as unknown as OptionsOrGroups<string, GroupBase<string>>}
                      id="updatePA"
                      isSearchable={false}
                      noOptionsMessage={() => "Select Option..."}
                      value={getValue()}
                      onChange={(value) => onChangeSelect(value)}
                  />
                </div>
                <div className="col-12 col-md-2 text-end mt-3 mt-md-0">
                  <button
                      type="button"
                      className="btn btn-success rounded-0 px-4"
                      onClick={UpdatePrecertButton}
                      // disabled={loading}
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-3"><FooterText footerType="black"/></div>
        </div>
      </div>
  );
};

export default UpdatePrecert;
